import { render, staticRenderFns } from "./MainFooterMenu.vue?vue&type=template&id=2535310e"
import script from "./MainFooterMenu.vue?vue&type=script&lang=js"
export * from "./MainFooterMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2535310e')) {
      api.createRecord('2535310e', component.options)
    } else {
      api.reload('2535310e', component.options)
    }
    module.hot.accept("./MainFooterMenu.vue?vue&type=template&id=2535310e", function () {
      api.rerender('2535310e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/main/MainFooterMenu.vue"
export default component.exports